import styled from '@emotion/styled';
import { spacing, palette, borderRadius, breakpoints } from 'theme';

export const TimesList = styled.div({
  width: '100%',
  maxWidth: '350px',

  borderRadius: borderRadius.lg,
  padding: `${spacing[24]} clamp(${spacing[28]}, 6%, ${spacing[48]})`,
  backgroundColor: palette.neutral[100],

  display: 'grid',
  gridTemplateColumns: '10ch 18ch',
  rowGap: spacing[8],
  marginInline: 'auto',

  [`${breakpoints.mobile}`]: {
    marginInline: '0',
  },
});
